import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly childFactorClipboard: string = 'miradi_child_factor_clipboard';
  private readonly dashboardLogoutReturn: string = 'miradi_dashboard_logout_return';
  private readonly diagramClipboard: string = 'miradi_diagram_clipboard';
  private readonly diagramClipboardFormat: string = 'miradi_diagram_clipboard_format';
  private readonly integratedDashboardSignOutUrl: string = 'miradi_integrated_dashboard_sign_out_url';

  constructor () {
  }

  getChildFactorClipboard(): any {
    return JSON.parse(localStorage.getItem(this.childFactorClipboard || null));
  }

  setChildFactorClipboard(clipboard: any): void {
    localStorage.setItem(this.childFactorClipboard, JSON.stringify(clipboard));
  }

  // Kept in localStorage rather than sessionStorage: the reader may close the
  // browser after logging out and only sign in again days later.
  getDashboardLogoutReturn(): { url: string, userIdentifier: string } {
    return JSON.parse(localStorage.getItem(this.dashboardLogoutReturn) || null);
  }

  setDashboardLogoutReturn(value: { url: string, userIdentifier: string }): void {
    if (value) localStorage.setItem(this.dashboardLogoutReturn, JSON.stringify(value));
    else localStorage.removeItem(this.dashboardLogoutReturn);
  }

  getDiagramClipboard(): any {
    return JSON.parse(localStorage.getItem(this.diagramClipboard || null));
  }

  setDiagramClipboard(clipboard: any): void {
    localStorage.setItem(this.diagramClipboard, clipboard?.toJson ? clipboard?.toJson() : JSON.stringify(clipboard));
  }

  getDiagramClipboardFormat(): string {
    return localStorage.getItem(this.diagramClipboardFormat) || '';
  }

  setDiagramClipboardFormat(clipboardFormat: string): void {
    localStorage.setItem(this.diagramClipboardFormat, clipboardFormat);
  }

  // Shared by every tab of this origin on purpose: the tab that opens a
  // dashboard is not the tab the reader logs out from.
  getIntegratedDashboardSignOutUrl(): string {
    return localStorage.getItem(this.integratedDashboardSignOutUrl) || '';
  }

  setIntegratedDashboardSignOutUrl(signOutUrl: string): void {
    localStorage.setItem(this.integratedDashboardSignOutUrl, signOutUrl);
  }

}
